import styled, { css } from 'styled-components';
import { applyTypographyOf } from 'style-utils/typographic-scale';

const baseHeadingStyles = css`
  font-weight: 500;
  line-height: 1.2;
`;

export const H1 = styled.h1`
  ${applyTypographyOf('h1')};
  ${baseHeadingStyles};
  font-weight: 700;
`;

export const H2 = styled.h2`
  ${applyTypographyOf('h2')};
  ${baseHeadingStyles};
`;

export const H3 = styled.h3`
  ${applyTypographyOf('h3')};
  ${baseHeadingStyles};
`;
export const H4 = styled.h4`
  ${applyTypographyOf('h4')};
  ${baseHeadingStyles};
`;
export const H5 = styled.h5`
  ${applyTypographyOf('h5')};
  ${baseHeadingStyles};
`;
export const H6 = styled.h6`
  ${applyTypographyOf('h6')};
  ${baseHeadingStyles};
`;
